import { render } from "./SectionFlow.vue?vue&type=template&id=4871505e"
import script from "./SectionFlow.vue?vue&type=script&lang=js"
export * from "./SectionFlow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__